import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { RxCalendar } from "react-icons/rx";
import { AuthContext } from "../../../contexts/AuthContext";
import { handleCountBookings } from "../../../apis/bookings";

export default function FulfilledWidget() {
  const { site } = useContext(AuthContext);

  const { data: count } = useQuery({
    queryKey: ["fulfilledCount", site?._id],
    queryFn: () =>
      handleCountBookings({
        site: site?._id === 0 ? "" : site?._id,
        isConfirmed: 1,
        isFulfilled: 1,
      }),
  });

  return (
    <div className="col-span-12 sm:col-span-6 md:col-span-3 border p-2 border-gray-300 bg-violet-100">
      <div className="flex">
        <div className="flex justify-center items-center w-14 h-14 bg-violet-200 border border-violet-300">
          <RxCalendar size={34} />
        </div>
        <div className="flex flex-col border-l border-violet-300 pl-2 ml-2">
          <div className="uppercase">Handled Bookings</div>
          <div className="font-bold text-2xl">{count}</div>
        </div>
      </div>
    </div>
  );
}
